import React, { useEffect, useState } from 'react';
import { Layout } from '../components/Layout';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Trophy, Medal, Award } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const RankingPage = () => {
  const [ranking, setRanking] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRanking();
  }, []);

  const fetchRanking = async () => {
    try {
      const { data } = await axios.get(`${BACKEND_URL}/api/stats/ranking`, {
        withCredentials: true,
      });
      setRanking(data);
    } catch (error) {
      toast.error('Erro ao carregar ranking');
    } finally {
      setLoading(false);
    }
  };

  const getPositionIcon = (position) => {
    if (position === 1) return <Trophy className="h-6 w-6 text-yellow-500" />;
    if (position === 2) return <Medal className="h-6 w-6 text-gray-400" />;
    if (position === 3) return <Award className="h-6 w-6 text-orange-600" />;
    return <span className="text-xl font-bold text-muted-foreground">#{position}</span>;
  };

  if (loading) {
    return (
      <Layout>
        <div className="flex items-center justify-center h-64">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="space-y-6" data-testid="ranking-page">
        <div>
          <h1 className="text-4xl font-black tracking-tight">Ranking de Lideranças</h1>
          <p className="text-muted-foreground mt-2">
            Desempenho das lideranças por redirecionamentos
          </p>
        </div>

        {ranking.length === 0 ? (
          <Card>
            <CardContent className="py-12 text-center">
              <p className="text-muted-foreground">
                Nenhum dado de ranking disponível ainda.
              </p>
            </CardContent>
          </Card>
        ) : (
          <div className="space-y-4">
            {ranking.slice(0, 3).map((item) => (
              <Card
                key={item.lideranca_id}
                className="border-2 border-primary/20"
                data-testid={`ranking-item-${item.posicao}`}
              >
                <CardHeader>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4">
                      {getPositionIcon(item.posicao)}
                      <div>
                        <CardTitle className="text-2xl">{item.nome}</CardTitle>
                        <p className="text-sm text-muted-foreground">
                          {item.apelido && `@${item.apelido} • `}{item.cidade}{item.bairro && `/${item.bairro}`}
                        </p>
                      </div>
                    </div>
                  </div>
                </CardHeader>
                <CardContent>
                  <div className="grid grid-cols-4 gap-4">
                    <div className="text-center">
                      <p className="text-3xl font-bold text-primary">{item.total_acessos}</p>
                      <p className="text-sm text-muted-foreground">Acessos</p>
                    </div>
                    <div className="text-center">
                      <p className="text-3xl font-bold text-primary">
                        {item.total_redirecionamentos}
                      </p>
                      <p className="text-sm text-muted-foreground">Redirecionamentos</p>
                    </div>
                    <div className="text-center">
                      <p className="text-3xl font-bold text-primary">{item.redirect_canal}</p>
                      <p className="text-sm text-muted-foreground">Canais</p>
                    </div>
                    <div className="text-center">
                      <p className="text-3xl font-bold text-primary">
                        {item.taxa_conversao}%
                      </p>
                      <p className="text-sm text-muted-foreground">Taxa</p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}

            {ranking.slice(3).map((item) => (
              <Card key={item.lideranca_id} data-testid={`ranking-item-${item.posicao}`}>
                <CardContent className="py-4">
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-4">
                      <div className="w-12 flex justify-center">
                        {getPositionIcon(item.posicao)}
                      </div>
                      <div>
                        <p className="font-bold">{item.nome}</p>
                        <p className="text-sm text-muted-foreground">
                          {item.apelido && `@${item.apelido} • `}{item.cidade}{item.bairro && `/${item.bairro}`}
                        </p>
                      </div>
                    </div>
                    <div className="flex gap-6 text-center">
                      <div>
                        <p className="text-lg font-bold text-primary">{item.total_acessos}</p>
                        <p className="text-xs text-muted-foreground">Acessos</p>
                      </div>
                      <div>
                        <p className="text-lg font-bold text-primary">
                          {item.total_redirecionamentos}
                        </p>
                        <p className="text-xs text-muted-foreground">Redirecionamentos</p>
                      </div>
                      <div>
                        <p className="text-lg font-bold text-primary">
                          {item.taxa_conversao}%
                        </p>
                        <p className="text-xs text-muted-foreground">Taxa</p>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};
